/* global google */
import React, { useContext, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Dashboard from "./component/pages/Dashboard";
import Account from "./component/pages/Account";
import Team from "./component/pages/Team";
import Carriers from "./component/pages/Carriers";
import Client from "./component/pages/Client";
import Users from "./component/pages/Users";
import Pricing from "./component/pages/Pricing";
import Settings from "./component/pages/Settings";
import ForgotPassword from "./component/pages/ForgotPassword";
import ResetPassword from "./component/pages/ResetPassword";
import Quotes from "./component/pages/Quotes";
import Orders from "./component/pages/Orders";
import Tracking from "./component/pages/Tracking";
import OrdersArchives from "./component/pages/OrdersArchives";
import LoadingContext from "./component/services/LoadingContext";
import LoaderComponent from "./component/customcomponents/LoaderComponent";
import PageNotFound from "./component/pages/PageNotFound";
import ClientLogin from "./component/pages/ClientLoign";
import Availabilities from "./component/pages/Availabilities";
import Home from "./component/pages/Home";
import Invoices from "./component/pages/Invoices";
import Claims from "./component/pages/Claims";
// WEB IMPORTS
import Header from "./web_components/inc/Header";
import Footer from "./web_components/inc/Footer";
import WebHome from "./web_components/pages/Home";
import Solutions from "./web_components/pages/Solutions";
import SolutionsCarrier from "./web_components/pages/SolutionsCarrier";
import WebContact from "./web_components/pages/Contact";
import WebLogin from "./web_components/pages/Login";
import TermsAndConditions from "./web_components/pages/Terms";
import Demo from "./web_components/pages/Demo";
import Join from "./web_components/pages/Join";
import SolutionsImg from "./web_components/images/solutions.webp";
import loginimg from "./web_components/images/login_img2.webp";
import Privacy from "./web_components/pages/Privacy";
import PrivateRoute from "./PrivateRoute";
import { AppStoreContext } from "./store/AppStore";

function ScrollToTopMain() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const { userDetail, isLoading, setIsLoading } = useContext(AppStoreContext);

  useEffect(() => {
    const img = new window.Image();
    img.src = SolutionsImg;
    img.src = loginimg;
    img.onload = () => {
      console.log("img.onload");
    };
  }, []);

  return (
    <Router basename={"/"}>
      <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
        {isLoading && <LoaderComponent userDetail={userDetail} />}
        <ScrollToTopMain />
        <Header />
        <Routes>
          {/* WEB */}
          <Route exact path="/" element={<WebHome />} />
          <Route path="/user_login" element={<WebLogin variant="user" />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/solutions/carrier" element={<SolutionsCarrier />} />
          <Route path="/contact" element={<WebContact />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/join" element={<Join />} />
          <Route
            path="/web_tracking"
            element={<Tracking isUserLogin={false} />}
          />
          <Route
            path={`/forget_password`}
            element={<ForgotPassword user_role={"Other"} />}
          />

          {/* ADMIN */}
          <Route path={`/login`} element={<WebLogin variant="admin" />} />
          <Route
            path={`/admin_forgotPassword`}
            element={<ForgotPassword user_role={"Admin"} />}
          />
          <Route
            path={`/staff_forgotPassword`}
            element={<ForgotPassword user_role={"Staff"} />}
          />

          <Route path={`/resetPassword`} element={<ResetPassword />} />
          <Route
            path={`/dashboard`}
            element={
              <PrivateRoute roles={["Admin", "Staff"]}>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/account"
            element={
              <PrivateRoute roles={["Admin", "Staff", "User", "Carrier", "Client"]}>
                <Account />
              </PrivateRoute>
            }
          />
          <Route
            path="/team"
            element={
              <PrivateRoute roles={["Admin"]}>
                <Team />
              </PrivateRoute>
            }
          />
          <Route
            path="/carriers"
            element={
              <PrivateRoute roles={["Admin", "Staff"]}>
                <Carriers />
              </PrivateRoute>
            }
          />
          <Route
            path="/clients"
            element={
              <PrivateRoute roles={["Admin", "Staff"]}>
                <Client />
              </PrivateRoute>
            }
          />
          <Route
            path="/users"
            element={
              <PrivateRoute roles={["Admin", "Staff"]}>
                <Users />
              </PrivateRoute>
            }
          />
          <Route
            path="/pricing"
            element={
              <PrivateRoute roles={["Admin"]}>
                <Pricing />
              </PrivateRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <PrivateRoute roles={["Admin", "Staff", "User", "Carrier", "Client"]}>
                <Settings />
              </PrivateRoute>
            }
          />

          {/* Staff */}
          <Route path="/staffLogin" element={<WebLogin variant="staff" />} />

          <Route
            path="/quotes"
            element={
              <PrivateRoute roles={["Staff", "User"]}>
                <Quotes />
              </PrivateRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <PrivateRoute roles={["Staff", "User", "Client", "Carrier"]}>
                <Orders />
              </PrivateRoute>
            }
          />
          <Route
            path="/archives"
            element={
              <PrivateRoute roles={["Staff", "User", "Client", "Carrier"]}>
                <OrdersArchives />
              </PrivateRoute>
            }
          />
          <Route
            path="/invoices"
            element={
              <PrivateRoute roles={["Admin", "Staff", "User", "Client"]}>
                <Invoices />
              </PrivateRoute>
            }
          />
          <Route
            path="/claims"
            element={
              <PrivateRoute roles={["Staff", "User", "Client", "Carrier"]}>
                <Claims />
              </PrivateRoute>
            }
          />
          <Route
            path="/tracking"
            element={
              <PrivateRoute roles={["Staff", "User", "Client", "Carrier"]}>
                <Tracking isUserLogin={true} />
              </PrivateRoute>
            }
          />

          {/* Carrier */}
          <Route
            path="/carrier_quotes"
            element={
              <PrivateRoute roles={["Carrier"]}>
                <Home />
              </PrivateRoute>
            }
          />
          <Route
            path="/carrier_home"
            element={
              <PrivateRoute roles={["Carrier"]}>
                <Home />
              </PrivateRoute>
            }
          />
          <Route
            path="/availabilities"
            element={
              <PrivateRoute roles={["Carrier"]}>
                <Availabilities />
              </PrivateRoute>
            }
          />

          {/* Client */}
          <Route path={`/clientLogin`} element={<ClientLogin />} />
          <Route path={`*`} element={<PageNotFound />} />
        </Routes>
        <Footer />
      </LoadingContext.Provider>
    </Router>
  );
}

export default App;
